export default 
{
	"progressbar-page-title": "Side",
	"name-suffix": "Suffiks",
	"fileupload-desc-progress-message": "Upload {progress}",
	"required-if-greater-than-or-equal": "{property} er påkrævet, når {compareSource} er større end eller lig med {compareValue}.",
	"powered-by-cognito": "Drevet af Cognito Forms.",
	"form-name-default": "Ikke-navngivet",
	"field-choice-defaults": "Første valg|Andet valg|Tredje valg",
	"additional-fee-default-label": "Ekstra gebyr",
	"authenticated-save-and-resume-email-dialog": "Send et link via e-mail, og vend tilbage til din formular for at fuldføre din indsendelse.",
	"string-length-between": "{property} skal være mellem {min} og {max} tegn.",
	"update-button-text": "Opdatere",
	"address-zip-code-invalid": "Zip Code skal være formateret som #####-####.",
	"required-if-greater-than": "{property} er påkrævet, når {compareSource} er større end {compareValue}.",
	"compare-before": "{property} skal være før {compareSource}.",
	"compare-after": "{property} skal være efter {compareSource}.",
	"unsupported-browser-message": "Åh nej! Du bruger en uunderbyggede browser. {a}Klik her{/a} for at opgradere.",
	"shared-entry-email-subject": "Delt Link",
	"send-button-text": "Send",
	"venmo-help-text": "Opret forbindelse til Venmo for at fortsætte med betalingen.",
	"field-repeatingsection-item-label": "Vare",
	"save-and-resume-email-not-sent-message": "Der var et problem.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} skal være mindst {min}.",
	"entry-notification-full-entry-detail-link": "Se fuld indrejse detaljer på cognitoforms.com.",
	"element-label-website": "Websted",
	"element-label-signature": "Underskrift",
	"paypal-help-text": "Opret forbindelse til PayPal for at fortsætte med betalingen.",
	"card-on-file-agreement-validation": "Du skal acceptere at gemme dit kort til fremtidige transaktioner.",
	"marketing-button-4": "Byg Din Egen Gratis",
	"field-datepicker-now": "Nu",
	"save-and-resume-email-resume-button": "Genoptag nu",
	"field-datepicker-next-month": "Næste måned",
	"quantity-remaining-text": "resterende",
	"payment-declined": "Betaling afvist",
	"required-if-before": "{property} er påkrævet, når {compareSource} er før {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} skal være mindre end {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} er påkrævet.",
	"save-and-resume-multiple-days-expiration-email-message": "Kopier eller email nedenstående link og vende tilbage til din form inden for de næste {days} dage for at fuldføre din indsendelse.",
	"string-length-at-least": "{property} skal være mindst {min} tegn.",
	"credit-card-number": "Kreditkortnummer",
	"range-on-or-before": "{property} skal være på eller før {max}.",
	"required-one": "{0} er påkrævet.",
	"fileupload-max-file-count-exceeded-message": "Kun {maxFileCount} filer kan uploades.",
	"order-transaction-details-header": "Transaktionsoplysninger",
	"field-spinner-increase": "Øge",
	"payment-processing-fees": "Behandling gebyrer",
	"payment": "Betaling",
	"field-choice-other-fill-in": "Andet",
	"shared-entry-email-message": "En post er blevet delt med dig.",
	"shared-entry-workflow-link": "Se formularen.",
	"required-if-exists": "{property} er påkrævet, når {compareSource} er angivet.",
	"concurrent-conflict-toast-message": "Din indsendelse mislykkedes, fordi oplysningerne i denne formular er ændret. Gennemgå venligst og prøv igen.",
	"secured-by-paypal": "Sikret af",
	"range-on-or-after": "{property} skal være på eller efter {min}.",
	"payment-amount-due": "Forfaldent beløb",
	"required-name-first-and-last": "Fornavn og Efternavn er påkrævet.",
	"required": "{property} er påkrævet.",
	"string-format-alphabetic": "{property} må kun indeholde bogstaver.",
	"quantity-limit": "{property} overskredet mængde.",
	"field-spinner-decrease": "Formindske",
	"field-repeatingsection-add-link-text": "Tilføj",
	"fileupload-max-size-exceeded-message": "Kun filer mindre end {maxSize} MB kan uploades.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Ikke Fanget",
	"field-ratingscale-satisfied-unsatisfied-label": "Tilfreds/Utilfreds",
	"range-between": "{property} skal være mellem {min} og {max}.",
	"field-ratingscale-agree-disagree-label": "Enig/Uenig",
	"back-button-text": "Tilbage",
	"address-country": "Land",
	"order-not-found": "Ingen ordre information fundet.",
	"field-ratingscale-satisfied-unsatisfied-options": "Meget utilfreds|Utilfreds|Neutral|Tilfreds|Meget tilfreds",
	"entry-notification-entry-details-header": "Post detaljer",
	"FALSE": "FALSK",
	"compare-greater-than-or-equal": "{property} skal være større end eller lig med {compareSource}.",
	"receipt-notification-order-details-desc-header": "Beskrivelse",
	"order-method-label": "Metode",
	"order-total-label": "Bestil Total",
	"invalid-shared-link": "Ugyldigt Shared Link",
	"fileupload-zero-byte-file-message": "Nul byte filer kan ikke uploades.",
	"range-at-most": "{property} skal være højst {max}.",
	"format-integer": "####",
	"order-date-label": "Dato",
	"fileupload-dropzone-message": "eller træk filer her.",
	"shared-entry-view-link": "Se den delte post.",
	"format-currency": "#.###,## kr.",
	"string-length-at-most": "{property} skal være højst {max} tegn.",
	"entry-confirmation-footer-tagline": "Opret din egen kraftfulde betaling former med",
	"submit-button-text": "Indsende",
	"marketing-msg": "Opret nemt kraftfulde former.",
	"required-if-on-or-after": "{property} er påkrævet, når {compareSource} er på eller efter {compareValue}.",
	"card-on-file-agreement": "Jeg accepterer at gemme mit kort til fremtidige transaktioner.",
	"signature-draw": "tegne",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} skal være på eller efter {compareSource}.",
	"required-if-less-than-or-equal": "{property} er påkrævet, når {compareSource} er mindre end eller lig med {compareValue}.",
	"field-datepicker-next-year": "Næste år",
	"change-button": "forandre",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Kort",
	"order-billing-info-header": "Fakturering Info",
	"entry-email-view-details-text": "Se hele indrejse ved CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Kopier eller email nedenstående link og vende tilbage til din form inden den næste dag for at fuldføre din indsendelse.",
	"credit-card-authentication-failed": "Kreditkort mislykkedes godkendelse.",
	"compare-less-than-or-equal": "{property} skal være mindre end eller lig med {compareSource}.",
	"receipt-notification-order-details-balance-due": "Balance behørig",
	"save-and-resume-multiple-days-expiration-message": "Kopier eller email nedenstående link og vende tilbage til din form inden for de næste {days} dage for at fuldføre din indsendelse.",
	"processing-fee-calculating-message": "Beregning af",
	"receipt-notification-trx-details-method": "Metode",
	"field-choice-no-match": "Ingen matchende data",
	"fileupload-invalid-file-type-message": "Kun {allowedTypes} filer kan uploades.",
	"receipt-notification-trx-details-date": "Dato",
	"credit-card-authorization": "Korttilladelse",
	"address-line1": "Adresselinje 1",
	"required-if-not-exists": "{property} er påkrævet, når {compareSource} ikke er angivet.",
	"required-if-not-equal": "{property} er påkrævet, når ikke er {compareSource} {compareValue}.",
	"marketing-button-2": "Byg Din Egen Gratis",
	"receipt-notification-billing-info-header": "Fakturering Info",
	"required-if-after": "{property} er påkrævet, når {compareSource} er efter {compareValue}.",
	"element-label-name": "Navn",
	"required-if-equal": "{property} er påkrævet, når {compareSource} {compareValue}.",
	"connected-to-paypal": "Forbundet til PayPal.",
	"people-form-email-quantity-exceeded-message": "E-mailadressen skal være unik.",
	"receipt-notification-order-details-subtotal": "Subtotal",
	"shared-entry-edit-link": "Rediger delte post.",
	"receipt-notification-trx-details-header": "Transaktionsoplysninger",
	"address-city": "By",
	"receipt-notification-order-details-amount-paid": "Beløb betalt",
	"credit-card-invalid": "Kortet er ugyldigt.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Du har en ny formularafsendelse.",
	"this-and-that": "{0} og {1}",
	"field-ratingscale-good-poor-label": "God/Dårlig",
	"network-unavailable-message": "Netværket er ikke tilgængeligt. Prøv igen senere.",
	"dialog-close": "Slutte",
	"string-format-alphanumeric": "{property}  må kun indeholde bogstaver og tal.",
	"credit-card": "Kreditkort",
	"remove-item": "Fjerne {item}",
	"receipt-notification-order-details-price-header": "Pris",
	"fileupload-upload-inprogress-message": "Fil upload i gang.",
	"public-terms-of-service-link-text": "Servicevilkår",
	"save-and-resume-email-subject": "Gem \u0026 Genoptag Link",
	"field-repeatingsection-remove-link-text": "Fjerne",
	"field-ratingscale-na-label": "NIELSEN",
	"add-item": "Tilføj {item}",
	"field-toggle-options": "Ja/Nej|Sand/Falsk|Åben/Lukket|Aktiv/Inaktiv|Læst/Ulæst",
	"order-submit-timeout": "Ordrebehandling tager alt for lang tid. Prøv din ordre senere.",
	"listlength-at-most": "Angiv venligst ikke mere end {max} {property}.",
	"shared-entry-email-view-message": "Brug linket nedenfor for at se den delte post.",
	"order-number-label": "Tal",
	"card-declined": "Kort afvist",
	"fileupload-default-upload-button-text": "Upload",
	"name-prefix": "Titel",
	"address-line2": "Adresselinje 2",
	"element-label-email": "E-mail",
	"field-ratingscale-good-poor-options": "Meget dårlig|Dårlig|Gennemsnitlige|God|Meget god",
	"next-button-text": "Næste",
	"question": "Spørgsmål",
	"address-postalcode": "Postnummer / Zip Code",
	"format-with-description": "{property} skal være formateret som {description}.",
	"field-datepicker-prev-month": "Forrige måned",
	"name": "Navn",
	"receipt-notification-order-details-total-footer": "Total",
	"confirmation-message": "Tak for at udfylde formularen. Dit svar er blevet registreret.",
	"shared-entry-email-edit-message": "Brug linket nedenfor for at redigere den delte post.",
	"field-default-label": "Ikke-navngivet",
	"required-value": "{property} skal være {value}.",
	"name-middle": "Mellemnavn",
	"fileupload-failed-upload-message": "{fileName} mislykkedes at uploade.",
	"shared-entry-email-button-label": "Se posten",
	"field-datepicker-year": "",
	"element-label-phone": "Telefon",
	"TRUE": "SANDT",
	"listlength-between": "Angiv venligst mellem {min} og {max} {property}.",
	"marketing-button-1": "Prøv Det Nu",
	"entry-submission-error-heading": "Fejl forarbejdning post",
	"order-not-found-message": "Ingen ordre information fundet.",
	"format-without-description": "{property} er ikke korrekt formateret.",
	"name-last": "Efternavn",
	"field-ratingscale-one-five-label": "Skala fra 1 til 5",
	"listlength-at-least": "Angiv mindst {min} {property}.",
	"united-states": "USA",
	"field-signature-captured": "Fanget",
	"compare-on-or-before": "{property} skal være på eller før {compareSource}.",
	"order-balance-due-label": "Balance behørig",
	"required-if-less-than": "{property} er påkrævet, når {compareSource} er mindre end {compareValue}.",
	"credit-card-postalcode": "Postnummer",
	"form-not-available-message": "Denne formular er ikke tilgængelig i øjeblikket.",
	"element-label-address": "Adresse",
	"receipt-notification-trx-details-number": "Tal",
	"public-submission-warning": "Indsend venligst ikke adgangskoder gennem Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Kopier eller email nedenstående link og vende tilbage til din formular for at fuldføre din indsendelse.",
	"fileupload-excluded-file-type-message": "Filer af denne type kan ikke uploades.",
	"payment-subtotal": "Subtotal",
	"collapse": "Skjule",
	"save-button-text": "Gem",
	"field-datepicker-prev-year": "Forrige år",
	"signature-type": "skrive",
	"order-amount-minimum": "Forfaldent beløb skal være mindst kr. 1,00.",
	"string-format-numeric": "{property} må kun indeholde tal.",
	"entry-confirmation-entry-details-header": "Post detaljer",
	"connected-to-venmo": "Forbundet til Venmo.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Kvittering",
	"clear": "Slette",
	"today": "I dag",
	"required-name-last": "Efternavn er påkrævet.",
	"marketing-button-3": "Prøv Det Nu",
	"expand": "Udvide",
	"compare-greater-than": "{property} skal være større end {compareSource}.",
	"field-ratingscale-will-wont-label": "Vil/Ikke Vil",
	"required-name-first": "Fornavn er påkrævet.",
	"save-and-resume-one-day-expiration-message": "Kopier eller email nedenstående link og vende tilbage til din form inden den næste dag for at fuldføre din indsendelse.",
	"required-asterisk": "påkrævet",
	"credit-card-required": "Kreditkort er påkrævet.",
	"address-state-province-region": "Stat / Provins / Region",
	"save-and-resume-email-sent-message": "E-mailen er blevet sendt.",
	"workflow-action": "Handling",
	"field-ratingscale-will-wont-options": "Endeligt vil ikke|Sandsynligvis ikke|Ikke sikker på|Sandsynligvis|Endeligt vil",
	"save-and-resume-email-label": "Email mig mit link:",
	"field-ratingscale-agree-disagree-options": "Stærkt uenig|Uenig|Neutral|Enig|Meget enig",
	"order-exception-order-already-paid": "Denne ordre der allerede er betalt.",
	"fileupload-download-text": "Download",
	"address-state": "Stat",
	"allowed-values": "{property} er ikke på listen over tilladte værdier.",
	"shared-entry-workflow-email-button-label": "Åbn formular",
	"compare-equal": "{property} skal være det samme som {compareSource}.",
	"field-datepicker-clear": "Ryd",
	"name-first": "Fornavn",
	"save-and-resume-message": "Dine fremskridt er blevet gemt.",
	"save-and-resume-no-expiration-message": "Kopier eller email nedenstående link og vende tilbage til din formular for at fuldføre din indsendelse.",
	"entry-notification-view-details-text": "Se Detaljer",
	"order-exception-default-message": "Ude af stand til at behandle posteringer.",
	"public-report-abuse-link-text": "Rapporter misbrug",
	"order-amount-paid": "Beløb betalt",
	"element-label-default": "Ikke-navngivet",
	"countries": "Afghanistan|Albanien|Algeriet|Amerikansk Samoa|Andorra|Angola|Anguilla|Antarktis|Antigua og Barbudas|Argentina|Armenien|Aruba|Aserbajdsjan|Australien|Bahamas|Bahrain|Bangladesh|Barbados|Hviderusland|Belgien|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnien-Hercegovina|Botswana|Brasilien|Brunei Darussalam|Bulgarien|Burkina Faso|Burundi|Cambodja|Cameroun|Canada|Cayman-øerne|Centralafrikanske Republik|Chile|Cocosøerne|Colombia|Comorerne|Congo, Republikken of (Brazzaville)|Cook-øerne|Costa Rica|Cuba|Cypern|Danmark|Demokratiske Republik Congo (Kinshasa)|Djibouti|Dominica|Dominikanske Republik|Ecuador|Egypten|El Salvador|Elfenbenskysten|Eritrea|Estland|Etiopien|Falklandsøerne|Fiji|Filippinerne|Finland|Forenede Arabiske Emirater|Frankrig|Fransk Guyana|Fransk Polynesien|Franske territorier, sydlige|Færøerne|Gabon|Gambia|Georgien|Ghana|Gibraltar|Grenada|Grækenland|Grønland|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissau|Guyana|Haiti|Holland|Hollandske Antiller|Honduras|Hong Kong|Indien|Indonesien|Irak|Iran (den Islamiske Republik af)|Irland|Island|Isle of Man|Israel|Italien|Jamaica|Japan|Jomfruøerne (britisk)|Jordan|Juleøen|Kap Verde-øerne|Kasakhstan|Kenya|Kina|Kirgisistan|Kiribati|Korea, demokratiske mennesker \u0027 s Rep. (Nordkorea)|Korea, Republikken (Sydkorea)|Kosovo|Kroatien|Kuwait|Lao, folk \u0027 s Demokratiske Republik|Lesotho|Letland|Libanon|Liberia|Libyen|Liechtenstein|Litauen|Luxembourg|Macau|Madagaskar|Nordmakedonien|Malawi|Malaysia|Maldiverne|Mali|Malta|Marokko|Marshalløerne|Martinique|Mauretanien|Mauritius|Mayotte|Mexico|Mikronesien, delstaterne|Moldova, Republikken|Monaco|Mongoliet|Montenegro|Montserrat|Mozambique|Myanmar, Burma|Namibia|Nauru|Nepal|New Zealand|Nicaragua|Niger|Nigeria|Niue|Nord-Marianerne|Norge|Ny Kaledonien|Oman|Pakistan|Palau|Palæstinensiske territorier|Panama|Papua Ny Guinea|Paraguay|Pavestolen|Peru|Pitcairn Island|Polen|Portugal|Puerto Rico|Qatar|Reunion ø|Rumænien|Russiske Føderation|Rwanda|Saint Kitts og Nevis|Saint Lucia|Saint Vincent og Grenadinerne|Salomonøerne|Samoa|San Marino|Sao Tome og Principe|Saudi-Arabien|Schweiz|Senegal|Serbien|Seychellerne|Sierra Leone|Singapore|Slovakiet (Slovakiske Republik)|Slovenien|Somalia|Spanien|Sri Lanka|Storbritannien|Sudan|Surinam|Sverige|Swaziland|Sydafrika|Sydsudan|Syrien, Syriske Arabiske Republik|Tadsjikistan|Taiwan (Folkerepublikken Kina)|Tanzania; officielt den Forenede Republik Tanzania|Tchad|Thailand|Tibet|Østtimor (Timor-Leste)|Tjekkiet|Togo|Tokelau|Tonga|Trinidad og Tobago|Tunesien|Turkmenistan|Turks og Caicos øerne|Tuvalu|Tyrkiet|Tyskland|Uganda|Ukraine|Ungarn|Uruguay|USA|Usbekistan|Vanuatu|Vatikanstaten (Pavestolen)|Venezuela|Vestsahara|Vietnam|Jomfruøerne (USA)|Wallis-og Futuna-øerne|Yemen|Zambia|Zimbabwe|Ækvatorial Guinea|Østrig",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Ordre skal indeholde mindst én linjevare.",
	"compare-not-equal": "{property} skal være forskellig fra {compareSource}.",
	"entry-notification-footer": "Du modtager denne e-mail, fordi du har valgt indstillingen modtag e-mail-meddelelser på din formular i Cognito Forms.",
	"save-and-resume-copy-link-label": "Kopier din formular link:",
	"entry-confirmation-footer": "Du modtager denne e-mail, fordi du afsluttet en transaktion med [Name].",
	"required-if-on-or-before": "{property} er påkrævet, når {compareSource} er på eller før {compareValue}.",
	"string-format": "{property} skal være formateret som {formatDescription}."
};
